import { combineReducers } from 'redux'

import { authReducer } from './auth/reducer'
import { organizationReducer } from './organization/reducer'
import { planCnpjServicesReducer } from './planCnpjServices/reducer'
import { planCpfServicesReducer } from './planCpfServices/reducer'
import { userReducer } from './user/reducer'
import { configReducer } from './config/reducer'

const appReducer = combineReducers({
  auth: authReducer,
  organization: organizationReducer,
  planCnpjServices: planCnpjServicesReducer,
  planCpfServices: planCpfServicesReducer,
  user: userReducer,
  config: configReducer,
})

export const Reducers = (state, action) => {
  // reset store in logout
  if (action.type === 'LOGOUT') {
    // state = undefined
     state = { config: state.config }
  }

  return appReducer(state, action)
}
